import React, { FC, memo } from 'react';
import classNames from 'classnames';
import { useIntl } from 'umi';
import noDataIcon from '@/pages/aigc/assets/svg/agent-no-data.svg';
import './index.scss';

interface ISkillsListEmptyProps {
  className?: string;
}

/**
 * Skills 列表空态（与技能集页 / Agent 集合空态结构一致：插图 + i18n 文案）
 */
const SkillsListEmpty: FC<ISkillsListEmptyProps> = ({ className }) => {
  const { formatMessage } = useIntl();

  return (
    <div
      className={classNames('dba-skills-collection__empty', className)}
    >
      <img src={noDataIcon} alt="" className="game-icon" />
      <p>{formatMessage({ id: 'dba_skills_collection_empty' })}</p>
    </div>
  );
};

export default memo(SkillsListEmpty);
